
const About = ()=>{
    return <>
<div class="card  ">
  <div class="card-body">
    <h5 class="card-title fw-bold">About</h5>
    <p class="card-text">
    This is a project built using React. It is a movie searching site like IMDb and uses IMDb's data. Due to limited API calls it has less features.
    </p>


  </div>
</div>
    </>
}
export default About